import Image1 from '../../images/10078.jpg'
import Image2 from '../../images/10142.jpg'
import Image3 from '../../images/10177.jpg'
import Image4 from '../../images/10179.jpg'
import Image5 from '../../images/10180.jpg'
import Image6 from '../../images/10182.jpg'
import Image7 from '../../images/10184.jpg'
import Image8 from '../../images/10185.jpg'
import Image9 from '../../images/10218.jpg'
import Image10 from '../../images/10219.jpg'
import Image11 from '../../images/10314.jpg'
import Image12 from '../../images/10332.jpg'
import Image13 from '../../images/16212b3912a129093bcd8a1b489929dd.jpg'
import Image14 from '../../images/45829afaca4802f9bdfb7aa8c823e48f.jpg'
import Image15 from '../../images/79a092cb931d9faf6c4b9e623743f377.jpg'
import Image16 from '../../images/8849.jpg'
import Image17 from '../../images/8863.jpg'
import Image18 from '../../images/893897c6271cf676fef4184e30147ddc.jpg'
import Image19 from '../../images/9101.jpg'
import Image20 from '../../images/9271.jpg'
import Image21 from '../../images/9783.jpg'
import Image22 from '../../images/9790.jpg'
import Image23 from '../../images/9791.jpg'
import Image24 from '../../images/9890.jpg'
import Image25 from '../../images/9987.jpg'
import Image26 from '../../images/IMG_20221112_195857.jpg'
import Image27 from '../../images/amongus.jpg'
import Image28 from '../../images/d069bf3cdd2106e58ae88f17f12ab4be.jpg'
import Image29 from '../../images/e0d85c577aec29bcf6821a90aa2a19b8.jpg'
import Image30 from '../../images/einshtain.jpg'
import Image31 from '../../images/f0db8d46698b4a07ed3bd97a216dfef1.jpg'
import Image32 from '../../images/fbc103071adeaa3f088e1e28b3872611.jpg'
import Image33 from '../../images/ronaldo.jpg'
import Image34 from '../../images/ronaldo_post.jpg'
import Image35 from '../../images/add-pic.png'
import Image36 from '../../images/search.png'
import Image37 from '../../images/add.png'
import Image38 from '../../images/angry.png'
import Image39 from '../../images/haha.png'
import Image40 from '../../images/wow.png'
import Image41 from '../../images/care.png'
import Image42 from '../../images/sad.png'
import Image43 from '../../images/like.png'
import Image44 from '../../images/love.png'
import Image45 from '../../images/close.png'
import Image46 from '../../images/more.png'
import Image47 from '../../images/comment.png'
import Image48 from '../../images/thumb.png'
import Image49 from '../../images/share.png'
import Image50 from '../../images/earth.png'
import Image51 from '../../images/friends.png'
import Image52 from '../../images/group.png'
import Image53 from '../../images/home.png'
import Image54 from '../../images/home-active.png'
import Image55 from '../../images/requests.png'
import Image56 from '../../images/requests-active.png'
import Image57 from '../../images/watch.png'
import Image58 from '../../images/notifications.png'
import Image59 from '../../images/menu.png'
import Image60 from '../../images/market.png'
import Image61 from '../../images/messenger.png'
import Image62 from '../../images/verified.png'
import Image63 from '../../images/5933.jpg'
import Image64 from '../../images/5934.jpg'
import Image65 from '../../images/5935.jpg'
import Image66 from '../../images/5936.jpg'
import Image67 from '../../images/5937.jpg'
import Image68 from '../../images/5943.jpg'
import Image69 from '../../images/5944.jpg'
import Image70 from '../../images/5945.jpg'
import Image71 from '../../images/5946.jpg'
import Image72 from '../../images/5947.jpg'
import Image73 from '../../images/5953.jpg'
import Image74 from '../../images/5954.jpg'
import Image75 from '../../images/5955.jpg'
import Image76 from '../../images/5957.jpg'
import Image77 from '../../images/down.png'
import Image78 from '../../images/edit.png'
import Image79 from '../../images/profile-edit.png'
import Image80 from '../../images/profile.png'
import Image81 from '../../images/profile-active.png'
import Image82 from '../../images/followers.png'
import Image83 from '../../images/instagram.png'
import Image84 from '../../images/twitter.png'
import Image85 from '../../images/176.jpg'
import Image86 from '../../images/187.jpg'
import Image87 from '../../images/256.jpg'
import Image88 from '../../images/4271.jpg'
import Image90 from '../../images/10189.jpg'
import Image91 from '../../images/10176.jpg'
import Image92 from '../../images/9378.jpg'
import Image93 from '../../images/9819.jpg'
import Image94 from '../../images/10060.jpg'
import Image95 from '../../images/9981.jpg'
import Image96 from '../../images/6938.jpg'
import Image97 from '../../images/7446.jpg'
import Image98 from '../../images/7447.jpg'
import Image99 from '../../images/7789.jpg'
import Image100 from '../../images/10203.jpg'
import Image101 from '../../images/BochiGirlIcon.jpg'
import Image102 from '../../Assets/Pins/86_cover.jpg'
import Image103 from '../../Assets/Pins/abyss_meme.jpg'
import Image104 from '../../Assets/Pins/akatsuki_cover.jpg'
import Image105 from '../../Assets/Pins/anime_art.jpg'
import Image106 from '../../Assets/Pins/anime_art_1.jpg'
import Image107 from '../../Assets/Pins/aruma.jpg'
import Image108 from '../../Assets/Pins/aruma1.jpg'
import Image109 from '../../Assets/Pins/aruma2.jpg'
import Image110 from '../../Assets/Pins/bugs_bunny.jpg'
import Image111 from '../../Assets/Pins/cosmic_garou.jpg'
import Image112 from '../../Assets/Pins/david_1.jpg'
import Image113 from '../../Assets/Pins/dn_char.jpg'
import Image114 from '../../Assets/Pins/eren_cover.jpg'
import Image115 from '../../Assets/Pins/eren_manga.jpg'
import Image116 from '../../Assets/Pins/greyrat.jpg'
import Image117 from '../../Assets/Pins/greyrat1.jpg'
import Image118 from '../../Assets/Pins/greyrat2.jpg'
import Image119 from '../../Assets/Pins/haise1.jpg'
import Image120 from '../../Assets/Pins/hollow_knight_1.jpg'
import Image121 from '../../Assets/Pins/hornet1.jpg'
import Image122 from '../../Assets/Pins/ishida.jpg'
import Image123 from '../../Assets/Pins/light1.jpg'
import Image124 from '../../Assets/Pins/mewing_cat.jpg'
import Image125 from '../../Assets/Pins/minecraft_3_chickens.jpg'
import Image126 from '../../Assets/Pins/red_pixel_art_anime.jpg'
import Image127 from '../../Assets/Pins/rest_here.jpg'
import Image128 from '../../Assets/Pins/sad_wolf.jpg'
import Image129 from '../../Assets/Pins/slime.jpg'
import Image130 from '../../Assets/Pins/sukuna1.jpg'
import Image131 from '../../Assets/Pins/vegeta_hard_postion.jpg'

import bg1 from '../../Assets/bg/1607469.jpg'
import bg2 from '../../Assets/bg/19187761.jpg'

import post_1 from '../../Assets/Posts/denji_post.jpg'
import post_2 from '../../Assets/Posts/MaxPayne.jpg'

import yuuichi from '../../Assets/Pins/yuuichi.jpg'

const images = {
    cat: Image1,
    floppus: Image2,
    artisan1: Image3,
    ronaldo1: Image4,
    didin1: Image5,
    messi1: Image6,
    didinchan: Image7,
    artisan2: Image8,
    keneki1: Image9,
    yoshida1: Image10,
    megumi1: Image11,
    kaneki2: Image12,
    goku1: Image13,
    megumi2: Image14,
    ayanami1: Image15,
    makima1: Image16,
    cdgta5: Image17,
    eren1: Image18,
    weird1: Image19,
    itadori1: Image20,
    opmanga1: Image21,
    opmanga2: Image22,
    opmanga3: Image23,
    genos1: Image24,
    cgarou1: Image25,
    floppa1: Image26,
    amongus1: Image27,
    syc1: Image28,
    izumi1: Image29,
    einshtein1: Image30,
    ayanami2: Image31,
    itadori2: Image32,
    ronaldo2: Image33,
    bts1: Image34,
    addpic: Image35,
    search: Image36,
    add: Image37,
    angry: Image38,
    haha: Image39,
    wow: Image40,
    care: Image41,
    sad: Image42,
    like: Image43,
    love: Image44,
    close: Image45,
    more: Image46,
    comment: Image47,
    thumb: Image48,
    share: Image49,
    earth: Image50,
    friends: Image51,
    group: Image52,
    home: Image53,
    homeactive: Image54,
    requests: Image55,
    requestsactive: Image56,
    watch: Image57,
    notification: Image58,
    menu: Image59,
    market: Image60,
    messenger: Image61,
    verified: Image62,
    dncharacter: Image63,
    eren2: Image64,
    eren3: Image65,
    eren4: Image66,
    levi9: Image67,
    eren6: Image68,
    levi1: Image69,
    levi2: Image70,
    levi3: Image71,
    levi4: Image72,
    eren5: Image73,
    levi5: Image74,
    levi6: Image75,
    levi7: Image76,
    down: Image77,
    edit: Image78,
    profileedit: Image79,
    profile: Image80,
    profileactive: Image81,
    followers: Image82,
    instagram: Image83,
    twitter: Image84,
    kaneki3: Image85,
    ayanami3: Image86,
    goku2: Image87,
    opinion1: Image88,
    messi2: Image90,
    animeGirl1: Image91,
    jjk1: Image92,
    kishibe1: Image93,
    tsrbisa1: Image94,
    musicsCover: Image95,
    ronaldo3: Image96,
    nature1: Image97,
    leonk1: Image98,
    itadori3: Image99,
    cmGirl1: Image100,
    bochiGirl1: Image101,
    cover_86: Image102,
    abyss_meme: Image103,
    akatsuki_cover: Image104,
    anime_art: Image105,
    anime_art_1: Image106,
    aruma: Image107,
    aruma1: Image108,
    aruma2: Image109,
    bugs_bunny: Image110,
    cosmic_garou: Image111,
    david_1: Image112,
    dn_char: Image113,
    eren_cover: Image114,
    eren_manga: Image115,
    greyrat: Image116,
    greyrat1: Image117,
    greyrat2: Image118,
    haise1: Image119,
    hk_1: Image120,
    hornet1: Image121,
    ishida: Image122,
    light1: Image123,
    mewing_cat: Image124,
    mc_3_chicks: Image125,
    red_pixel: Image126,
    rest_here: Image127,
    sad_wolf: Image128,
    slime: Image129,
    sukuna1: Image130,
    vegeta_hard_pos: Image131,
    bg1: bg1,
    bg2: bg2,
    post1: post_1,
    post2: post_2,
    yuuichi: yuuichi
}; 

export default images